// Keep these in sync with the designation names stored in the users' designationMap.
export const AM_DESIGNATIONS = [
    "Affiliate AM",
    "Master Admin",
    "Paid Media AM",
    "Full Services AM",
];
// Designations allowed as a Primary Lead in the Opportunity/Creator/Partner directory drawers.
export const PRIMARY_LEAD_DESIGNATIONS = [
    "Affiliate Lead",
    "Affiliate AM",
    "Master Admin",
    "Paid Media AM",
    "Search lead",
];
export const OPERATOR_DESIGNATIONS = [
    "Search Lead",
    "Social Lead",
    "Email Lead",
    "Design Lead",
    "Affiliate Lead",
];
/**
 * Collect users belonging to the given designations, de-duplicated by _id
 * (a user may hold more than one designation) and sorted by full name.
 */
export const collectUsersByDesignations = (designationMap, designations) => {
    if (!designationMap)
        return [];
    const seen = new Set();
    const result = [];
    designations.forEach((designation) => {
        (designationMap[designation] || []).forEach((u) => {
            if (u && u._id && !seen.has(u._id)) {
                seen.add(u._id);
                result.push(u);
            }
        });
    });
    return result.sort((a, b) => `${a.first_name} ${a.last_name}`.localeCompare(`${b.first_name} ${b.last_name}`));
};
/** Clean list: trimmed, empties dropped, duplicates (case-insensitive) removed, order kept. */
export const toDesignationList = (value) => {
    const raw = Array.isArray(value) ? value : [value];
    const seen = new Set();
    const list = [];
    raw.forEach((item) => {
        if (typeof item !== "string")
            return;
        const name = item.trim();
        if (!name || seen.has(name.toLowerCase()))
            return;
        seen.add(name.toLowerCase());
        list.push(name);
    });
    return list;
};
/** "Paid Media AM" or "Paid Media AM, Search Lead". */
export const designationLabel = (value) => toDesignationList(value).join(", ");
